<ng-container *ngIf="hasAccess && link && ((isMobileRes$ | async | isTrue) ? inMobile : true) else projected">
  <span class="tw-cursor-pointer" [routerLink]="link"><ng-container [ngTemplateOutlet]="projected"/></span>
</ng-container>
<ng-template #projected><ng-content/></ng-template>
